import { Box, Button, CircularProgress, Grid } from "@mui/material";
import { useEffect, useState } from "react";
import { GetAPI } from "../../Components/Backend/GetAPI";
import { useNavigate } from "react-router-dom";
import { usePermiteAcesso } from "../../Components/Funcionais/Utils";
import TextField from "@mui/material/TextField";
import InputLabel from "@mui/material/InputLabel";
import MenuItem from "@mui/material/MenuItem";
import FormControl from "@mui/material/FormControl";
import Select from "@mui/material/Select";
import AddIcon from "@mui/icons-material/Add";
import GeralTable from "./PerfisTabela";
import APIAxios from "../../Api/APIAxios";
import Autocomplete from "@mui/material/Autocomplete";
import PageTitle from "../../Components/Layout/PageTitle";

const URL_SERVICE = "/perfis";

const PerfisListar = () => {
  //***************************************   AVISOS E LOADING ************************************************* */
  // CONTROLE DE AVISOS E ALERTAS
  //Funcão para fechar avisos e alertas
  usePermiteAcesso(2); //Administrador de Acessos
  const [avisoErro, setAvisoErro] = useState("");
  const [avisoSucesso, setAvisoSucesso] = useState("");
  const [loading, setLoading] = useState(false);
  //************************************************************************************************** */

  const apiAxios = APIAxios();

  const [cmpSelecao, setCmpSelecao] = useState(10); // default: descrição
  const [perfis, setPerfis] = useState([]);
  const Navigate = useNavigate();
  const [valorSelecionado, setValorSelecionado] = useState(""); // NOVO

  const handleListar = async (e) => {
    if (e) e.preventDefault();

    setLoading(true);
    setAvisoErro("");
    const response = await GetAPI(apiAxios, URL_SERVICE);

    setLoading(false);

    if (!response.success) {
      setAvisoErro(response.errorMessage);
    } else {
      setPerfis(response.data);
    }
  };

  useEffect(() => {
    handleListar();
  }, []);

  //Função para seleção de filtro
  const getAutocompleteOptions = () => {
    let options = [];

    switch (cmpSelecao) {
      case 10:
        options = perfis.map((profile) => profile.nome);
        break;

      default:
        return [];
    }

    options = [...new Set(options)]; // Remove duplicatas

    // Ordena de forma alfabética ou numérica
    return options.sort((a, b) => {
      if (typeof a === "string") return a.localeCompare(b); // ordenação alfabética
      return a - b; // ordenação numérica
    });
  };

  // NOVO: Filtra conforme o valor selecionado
  const perfisFiltrados = valorSelecionado
    ? perfis.filter((profile) => {
      const valor = valorSelecionado.toLowerCase();
        switch (cmpSelecao) {
          case 10:
            return profile.nome.toLowerCase().includes(valor);

          default:
            return true;
        }
      })
    : perfis;

  const handleIncluirPerfil = () => {
    Navigate("/perfis/incluir");
  };

  return (
    <Box>
      {/******************************* TITULO E FUNCIONALIDADES *************************/}
      <PageTitle
        caption="Perfis"
        subtitle="Listagem de Perfis"
        setAvisoErro={setAvisoErro}
        avisoErro={avisoErro}
        avisoSucesso={avisoSucesso}
        setAvisoSucesso={setAvisoSucesso}
        loading={loading}
        accentStyle
      />
      {/**********************************************************************************/}

      <Box sx={{ color: "red", marginBottom: 2 }}>
        <Grid container spacing={2} alignItems="center" sx={{ mb: 2 }}>
          {/* Filtro */}
          <Grid item xs={12} md={3}>
            <FormControl fullWidth>
              <InputLabel>Filtrar por:</InputLabel>
              <Select
                labelId="cmpSelecao"
                id="cmpSelecao"
                label="Filtrar por"
                value={cmpSelecao}
                onChange={(e) => setCmpSelecao(e.target.value)}
              >
                <MenuItem value={10}>Perfil</MenuItem>
              </Select>
            </FormControl>
          </Grid>
          {/* Campo de busca */}
          <Grid item xs={12} md={3}>
            <Autocomplete
              id="cmpDescricao"
              freeSolo
              options={getAutocompleteOptions()}
              value={valorSelecionado}
              onInputChange={(event, newValue) => setValorSelecionado(newValue)}
              renderInput={(params) => (
                <TextField {...params} label="Localizar" fullWidth />
              )}
            />
          </Grid>

          {/* Espaço vazio para equilíbrio */}
          <Grid item xs={12} md={3}></Grid>

          {/* Botão Incluir */}
          <Grid
            item
            xs={12}
            md={3}
            sx={{ display: "flex", justifyContent: "flex-end" }}
          >
            <Button
              fullWidth
              variant="contained"
              startIcon={<AddIcon />}
              sx={{ backgroundColor: "#1a3865" }}
              onClick={handleIncluirPerfil}
            >
              Incluir perfil
            </Button>
          </Grid>
        </Grid>
        <GeralTable perfis={perfisFiltrados} setPerfis={setPerfis} />
      </Box>
    </Box>
  );
};

export default PerfisListar;
